import { inject, Signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { map } from 'rxjs';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

export interface UnsavedChanges {
  readonly form: Signal<NgForm>;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChanges> = (
  component,
) => {
  if (!component.form().dirty) {
    return true;
  }

  const dialog = inject(MatDialog);

  const dialogRef = dialog.open(ConfirmationDialogComponent, {
    data: {
      title: 'Are you sure?',
      content:
        'You have unsaved changes. You will lose your changes if you leave the form',
    },
  });

  return dialogRef.afterClosed().pipe(map((value) => !!value));
};
